const ApplicationNavigation = ({ index, total, loading, error, busy, filtered, onPrevious, onNext, onBack, onRetry, position }) => (
  <nav className="vu-navigation" aria-label={`Application navigation (${position})`}>
    <button type="button" className="vu-back-button" onClick={onBack} disabled={busy}>
      <span aria-hidden="true">← </span>Back to applications
    </button>
    <div className="vu-navigation-position" aria-live="polite">
      {loading ? "Loading navigation..." : error ? (
        <><span>{error}</span> <button type="button" className="vu-back-button" onClick={onRetry}>Retry navigation</button></>
      ) : index >= 0 ? (
        <><strong>Application {index + 1} of {total}</strong>{filtered && <span>Filtered results</span>}</>
      ) : "Not in the current application list"}
    </div>
    <div className="vu-navigation-buttons">
      <button type="button" className="vu-nav-button" aria-label="Previous application" disabled={busy || loading || !!error || index <= 0} onClick={onPrevious}>
        <span aria-hidden="true">←</span> Previous
      </button>
      <button type="button" className="vu-nav-button vu-nav-next" aria-label="Next application" disabled={busy || loading || !!error || index < 0 || index >= total - 1} onClick={onNext}>
        Next <span aria-hidden="true">→</span>
      </button>
    </div>
  </nav>
);

export default ApplicationNavigation;
